import {
  Box as MuiBox,
  Typography as MuiTypography,
  Avatar as MuiAvatar,
  useTheme,
} from '@mui/material';
import defineSex from 'pages/ProfileSettingsPage/utils/defineSex';
import { SDot, SIcon } from './styled';
import { countAge } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import LastActivityBadge from './LastActivityBadge';

type TableUserInfoProps = {
  user: {
    photoUrl: string;
    name: {
      firstName: string;
      lastName: string;
    };
    firstName: string;
    lastName: string;
    gender: string;
    email: string;
    birthDate: string;
    isSelfRegistered: boolean;
    lastActivity: string | null;
  };
  isPatient: boolean;
  isActive: boolean;
  onCellClick?: () => void;
  isDialog?: boolean;
};

export default function TableUserInfo({
  user,
  isPatient,
  isActive,
  onCellClick,
  isDialog = false,
}: TableUserInfoProps) {
  const { t } = useTranslation();
  const theme = useTheme()
  return (
    <MuiBox
      onClick={onCellClick}
      style={{
        display: 'flex',
        gap: 15,
        alignItems: 'center',
        filter: isActive ? 'none' : 'grayscale(100%)',
        opacity: isActive ? 1 : 0.8,
        cursor: onCellClick ? 'pointer' : 'default',
      }}
    >
      <MuiAvatar sx={{ width: 60, height: 60 }} src={user.photoUrl} />
      <MuiBox display="flex" flexDirection="column" style={{ width: '100%' }}>
        <MuiTypography variant="body1">
          {isPatient
            ? `${user?.name?.firstName?.[0]} ${user?.name?.lastName}`
            : `${user?.firstName} ${user?.lastName}`}
        </MuiTypography>
        {isPatient ? (
          <>
            <MuiTypography
              variant="subtitle1"
              style={{
                color: theme.palette.colors.gray400,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <SIcon style={{ fill: 'black' }}>{defineSex(user.gender)}</SIcon>
              <SDot />
              <p>
                {t(countAge(user.birthDate).text, {
                  age: countAge(user.birthDate).age,
                })}
              </p>
            </MuiTypography>
            {!isDialog && (
              <LastActivityBadge
                isSelfRegistered={user.isSelfRegistered}
                lastActivity={user.lastActivity}
              />
            )}
          </>
        ) : (
          <MuiTypography
            variant="subtitle1"
            style={{
              color: theme.palette.colors.gray400,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            {user.email}
          </MuiTypography>
        )}
      </MuiBox>
    </MuiBox>
  );
}
